import axios from '../../../../utills/axiosConfig';

export const fetchDepartments = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/departments', { params });
  return res.data;
};

export const addDepartment = async (department) => {
  try {
    const res = await axios.post('/departments', department);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateDepartment = async (id, department) => {
  console.log('API call - Updating department:', id, department);
  const res = await axios.put(`/departments/${id}`, department);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteDepartment = async (id) => {
  const res = await axios.delete(`/departments/${id}`);
  return res.data;
};

export const importDepartmentCSV = async (formData) => {
  const { data } = await axios.post('/departments/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 